import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TAttachmentsApi } from './types';

export const attachments: TAttachmentsApi = {
	getTypes: () => http.get(endpoint.attachments.GET_TYPES).then(response => response.data),
	getList: payload =>
		http
			.get(endpoint.attachments.LIST(payload.emId), {
				params: {
					pageSize: payload.pageSize,
					pageNumber: payload.pageNumber,
				},
			})
			.then(response => response.data),
	upload: payload =>
		http.post(endpoint.attachments.UPLOAD(payload.emId), payload.formData).then(() => {}),
	getOneByEmId: payload =>
		http
			.get(endpoint.attachments.GET_ONE(payload.emId, payload.attachmentId), {
				responseType: 'blob',
			})
			.then(response => response.data),
	delete: payload =>
		http.delete(endpoint.attachments.DELETE(payload.emId, payload.attachmentId)).then(() => {}),
	downloadByAttachmentId: payload =>
		http
			.get(endpoint.attachments.DOWNLOAD(payload.attachmentId), {
				responseType: 'blob',
				// params: {
				// 	emId: payload.emId,
				// },
			})
			.then(response => response.data),
};
